import TableOfContent from './TableOfContent';

export default TableOfContent;
